import { cn } from "@faire/react/tools/cn";
import { MODAL_INITIAL_FOCUS_ATTR } from "@faire/slate/private/modal/consts";
import React from "react";

type IProps = React.PropsWithChildren<{
  className?: string;
}>;

export const ModalHeaderCustomSlotFocus: React.FC<IProps> = ({
  children,
  className,
}) => (
  <div
    className={cn("fs-modal__header-slot", className)}
    tabIndex={-1}
    {...{ [MODAL_INITIAL_FOCUS_ATTR]: "" }}
  >
    {children}
  </div>
);
